import {Record} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import Image, {type Image as ImageRecord} from 'web-app/react/entities/common/image';
import {
    type CustomStatusStats,
    type PeopleStats,
    peopleStatsFromAPI,
    customStatusStatsFromAPI,
} from 'web-app/react/entities/groups/model';

export function fromAPI(data) {
    return new Tag({
        ...data,
        behaviors: new BehaviorsCollection(data.behaviors),
        stats: data.stats
            ? {
                  children: data.stats.children ? peopleStatsFromAPI(data.stats.children) : undefined,
                  employees: data.stats.employees ? peopleStatsFromAPI(data.stats.employees) : undefined,
              }
            : undefined,
        statusRegistrationStats: data.statusRegistrationStats
            ? {
                  children: data.statusRegistrationStats.children
                      ? data.statusRegistrationStats.children.map(customStatusStatsFromAPI)
                      : undefined,
                  employees: data.statusRegistrationStats.employees
                      ? data.statusRegistrationStats.employees.map(customStatusStatsFromAPI)
                      : undefined,
              }
            : undefined,
        image: Image.fromAPI(data.image),
    });
}

export class Tag extends Record<{
    tagId: string;
    title: string;
    behaviors: BehaviorsCollection;
    color?: string;
    famlyId: string;
    image?: ImageRecord;
    institutionId: string;
    starred: boolean;
    starring: boolean;
    stats?: {
        children?: PeopleStats;
        employees?: PeopleStats;
    };
    statusRegistrationStats?: {
        children?: CustomStatusStats[];
        employees?: CustomStatusStats[];
    };
}>({
    tagId: '',
    title: '',
    behaviors: new BehaviorsCollection([]),
    color: undefined,
    famlyId: '',
    image: undefined,
    institutionId: '',
    starred: false,
    starring: false,
    stats: undefined,
    statusRegistrationStats: undefined,
}) {}

export default {
    fromAPI,
    Tag,
};
